import { useEffect } from "react";

const BASE = "https://rossetconciergerie.ch";

const setMeta = (name, content) => {
  let m = document.querySelector(`meta[name="${name}"]`);
  if (!m) {
    m = document.createElement("meta");
    m.setAttribute("name", name);
    document.head.appendChild(m);
  }
  m.setAttribute("content", content);
};

export const Seo = ({ title, description, path = "/" }) => {
  useEffect(() => {
    document.title = title;
    if (description) setMeta("description", description);
    let link = document.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", `${BASE}${path}`);
  }, [title, description, path]);
  return null;
};
